export const getMicStream = async (): Promise<MediaStream> => {
    const permission = await navigator.permissions.query({name: 'microphone' as PermissionName});
    if (permission.state === 'denied') throw new Error('MIC_BLOCKED');
    return navigator.mediaDevices.getUserMedia({audio: true});
};
